import React from "react";
import FeatureCategory from "../../featurecategory";
import SEO from "../../seo";

export default function PocketedSpringPage() {
  const categoryName = "Pocketed Spring";

  const products = [
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Coil-on-Coil-1.png",
      name: "COIL ON COIL",
      link: "/patent-series-mattress/coil-on-coil/",
      price: 125099,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Tiara-Cool-1.png",
      name: "TIARA COOL",
      link: "/patent-series-mattress/tiara-cool/",
      price: 78999,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Accolade.png",
      name: "ACCOLADE PT",
      link: "/patent-series-mattress/accolade-pt/",
      price: 36899,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Oslo-Plush12.png",
      name: "HEALTHSENSE ET",
      link: "/patent-series-mattress/healthsense-et/",
      price: 34799,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Posture-comfort-PT.png",
      name: "POSTURE COMFORT",
      link: "/luxury-collection/posture-comfort/",
      price: 24199,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/portofino-Latex.png",
      name: "PORTOFINO LATEX",
      link: "/latex-mattress/portofino-latex/",
      price: 19399,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Portofino-PT.png",
      name: "PORTOFINO PT",
      link: "/conformatic-mattress/portofino-pt/",
      price: 15999,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Portofino.png",
      name: "PORTOFINO",
      link: "/serene-series/portofino/",
      price: 14599,
    },
  ];

  const categoryDescription =
    "Pocket Spring systems have springs or coils encased in individual and unconnected fabric pockets- reducing movement transfer while delivering consistent, high quality support.<br/><br/>Explore handcrafted spring mattresses that help you sleep disturbance free in excellent comfort.";

  return (
    <div>
      <SEO
        title="Pocketed Spring Mattress | Eclipse International"
        description="Explore range of luxury mattresses pocketed springs for zero movement transfer and the best firm support- finest quality assured with a 10 year warranty. "
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-main.jpg"
      />
      <FeatureCategory
        products={products}
        categoryName={categoryName}
        categoryDescription={categoryDescription}
      />
    </div>
  );
}
